import { useEffect, useState } from "react";

import { type ProductPriceType } from "@jti/fe-common";
import { useMessageBus } from "@jti/fe-message-bus";

export type UseSyncProductWithCartProductData = {
  sku: string;
  priceInformation: ProductPriceType | null;
  hidePrice: boolean | undefined;
  isCommerceDisabled: boolean | undefined;
};

export type UseSyncProductWithCartReturn = {
  isCartLoaded: boolean;
  quantityLimit: number;
  isQuantityLimitReached: boolean;
  shouldRenderPrice: boolean;
};

export const useSyncProductWithCart = (
  productData: UseSyncProductWithCartProductData
): UseSyncProductWithCartReturn => {
  const { sku, priceInformation, hidePrice } = productData;

  const messageBus = useMessageBus();

  const [isCartLoaded, setIsCartLoaded] = useState(false);
  const [quantityLimit, setQuantityLimit] = useState<number>(0);
  const [isQuantityLimitReached, setIsQuantityLimitReached] = useState(false);

  const isZeroPrice = priceInformation?.finalPrice?.value === 0;
  const isHiddenZeroPrice = isZeroPrice && hidePrice;

  useEffect(() => {
    messageBus.subscribe({
      channel: "cart.limit.update",
      callback: ({ payload }) => {
        if (sku === payload.sku) {
          setQuantityLimit(payload.limit);
          setIsQuantityLimitReached(payload.quantityLimitReached);
        }
      },
    });

    messageBus.subscribe({
      channel: "cart.loaded",
      callback: () => {
        setIsCartLoaded(true);
      },
    });

    return () => {
      messageBus.unsubscribe("cart.loaded");
      messageBus.unsubscribe("cart.limit.update");
    };
  }, [sku]);

  return {
    isCartLoaded,
    quantityLimit,
    isQuantityLimitReached,
    shouldRenderPrice: !isHiddenZeroPrice,
  };
};
